export default [
  { source: 'Oscar Wilde', text: 'Sii te stesso; tutto il resto è già preso.' },
  {
    source: 'Oscar Wilde',
    text: 'Perdona sempre i tuoi nemici. Nulla li fa arrabbiare di più.'
  },
  {
    source: 'Virginia Satir',
    text: 'Non dobbiamo permettere alle percezioni limitate degli altri di definire chi siamo.'
  },
  {
    source: 'William Shakespeare',
    text: 'Ma soprattutto tieni questo in mente: sii sempre , e resta, fedele a te stesso.'
  },
  {
    source: 'Helen Keller',
    text: 'Camminare con un amico al buio è meglio che camminare da soli nella luce.'
  },
  {
    source: 'Winston Churchill',
    text: 'Il coraggio è quello che ci vuole per alzarsi e parlare. Il coraggio è anche quello che ci vuole per sedersi ed ascoltare.'
  },
  {
    source: 'Martin Luther King, Jr.',
    text: 'Il perdono non è un atto occasionale; è un atteggiamento costante.'
  },
  { source: 'J.R.R. Tolkien', text: 'Il coraggio si trova in luoghi improbabili.' },
  { source: 'J.R.R. Tolkien', text: "Finché c'è vita c'è speranza." },
  {
    source: 'J.R.R. Tolkien',
    text: 'Non è la forza del corpo che conta, ma la forza dello spirito.'
  },
  {
    source: 'Dr. Seuss',
    text: 'Sii ciò che sei e dì ciò che senti, perché quelli a cui importa non contano e a quelli che contano non importa.'
  },
  {
    source: 'Stephen King',
    text: 'Non si può negare la risata; quando arriva, si accomoda sulla tua poltrona preferita e resta lì per tutto il tempo che vuole.'
  },
  {
    source: 'Abraham Lincoln',
    text: 'Nessuno ha una memoria tanto buona da poter essere un perfetto bugiardo.'
  },
  { source: 'Mark Twain', text: 'Tutte le generalizzazioni sono false, inclusa questa.' },
  { source: 'Ronald Reagan', text: 'Una foto vale 1.000 smentite.' },
  {
    source: 'Eleanor Roosevelt',
    text: 'Grandi menti parlano di idee, menti mediocri parlano di fatti, menti piccole parlano di persone.'
  },
  {
    source: 'J.K. Rowling',
    text: 'Sono le scelte che facciamo che dimostrano quel che siamo veramente, molto più delle nostre capacità.'
  },
  {
    source: 'Dax Shephard',
    text: 'Il successo è una guerra di logoramento. Di certo bisogna possedere un minimo di talento. Ma se rimani focalizzato, prima o poi qualcosa succederà.'
  },
  {
    source: 'Katherine Hepburn',
    text: 'Se fai sempre ciò che ti interessa, almeno una persona sarà contenta.'
  },
  {
    source: 'Audrey Hepburn',
    text: 'Nulla è impossibile, il mondo stesso dice: io sono possibile!'
  },
  {
    source: 'Wilma Rudolph',
    text: 'Non sottovalutare mai il potere dei sogni e l’influenza dello spirito umano. Siamo tutti uguali in questa nozione. Il potenziale di grandezza vive in ognuno di noi.'
  },
  {
    source: 'Francois de La Rochefoucauld',
    text: 'Per raggiungere la grandezza si dovrebbe vivere come se non si morirà mai.'
  },
  {
    source: 'Edmund Hillary',
    text: 'Le persone non decidono di diventare straordinarie. Decidono di realizzare cose straordinarie.'
  },
  {
    source: 'Albert Einstein',
    text: 'Una persona che non ha mai commesso un errore non ha mai provato nulla di nuovo.'
  },
  {
    source: 'Jimmy Dean',
    text: 'Non posso cambiare la direzione del vento, ma posso aggiustare le vele per raggiungere sempre la mia destinazione.'
  },
  {
    source: 'Nelson Mandela',
    text: 'Un vincitore è semplicemente un sognatore che non si è mai arreso.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'Nessuno può farti sentire inferiore senza il tuo consenso.'
  },
  {
    source: 'Henry Ford',
    text: 'Che tu creda di farcela o di non farcela, avrai comunque ragione.'
  },
  {
    source: 'Alice Walker',
    text: 'Il modo più comune in cui le persone rinunciano al loro potere è pensare che non ne abbiano.'
  },
  {
    source: 'Oprah Winfrey',
    text: 'Sii grato per quello che hai e finirai per averne di più. Se ti concentri su ciò che non hai, non avrai mai, mai abbastanza.'
  },
  {
    source: 'Hellen Keller',
    text: 'Quando una porta della felicità si chiude, se ne apre un’altra; ma tante volte guardiamo così a lungo quella chiusa, che non vediamo quella che è stata aperta per noi.'
  },
  {
    source: 'George Addair',
    text: 'Tutto ciò che hai sempre desiderato è dall’altra parte della paura.'
  },
  {
    source: 'Amelia Earhart',
    text: 'La cosa più difficile è la decisione di agire, il resto è solo tenacia.'
  },
  {
    source: 'George Whitefield',
    text: 'Vai avanti. Non fermarti, non indugiare nel tuo viaggio, ma cerca l’obiettivo che hai davanti.'
  },
  {
    source: 'Charles Swindoll',
    text: 'La vita è per il 10% ciò che ti accade e per il 90% come reagisci.'
  },
  {
    source: 'Michael Phelps',
    text: 'Ci saranno degli ostacoli. Ci saranno dei dubbiosi. Ci saranno degli errori. Ma col duro lavoro, non ci sono limiti.'
  },
  {
    source: 'Babe Ruth',
    text: 'Non si può battere una persona che non si arrende mai.'
  },
  {
    source: 'Thomas Edison',
    text: 'Molti dei fallimenti della vita sono di persone che non si sono rese conto di quanto fossero vicine al successo quando hanno rinunciato.'
  },
  {
    source: 'Aristotle Onassis',
    text: 'È nei nostri momenti più bui che dobbiamo concentrarci per vedere la luce.'
  },
  {
    source: 'Eleanor Roosevelt',
    text: 'Con il nuovo giorno arrivano una nuova forza e nuovi pensieri.'
  },
  {
    source: 'Robert Louis Stevenson',
    text: 'Non giudicare ogni giorno dal raccolto che raccogli ma dai semi che pianti.'
  },
  {
    source: 'Vincent Van Gogh',
    text: 'Se senti una voce dentro di te che dice ’non puoi dipingere’, allora a tutti i costi dipingi e quella voce verrà messa a tacere'
  },
  {
    source: 'Roy T. Bennett',
    text: 'Non lasciarti trascinare dalle paure della tua mente. Lasciati guidare dai sogni nel tuo cuore.'
  },
  {
    source: 'Mark Cuban',
    text: 'Svegliati sempre con un sorriso sapendo che oggi ti divertirai a realizzare ciò che gli altri hanno troppa paura di fare.'
  },
  {
    source: 'Maya Angelou',
    text: 'Se qualcosa non ti piace, cambiala.  Se non puoi cambiarla, cambia il tuo atteggiamento.'
  },
  {
    source: 'Jesse Owens',
    text: 'Trova il bene. È tutto intorno a te. Trovalo, dimostralo e comincerai a crederci.'
  },
  {
    source: 'Audre Lorde',
    text: 'Se non mi definissi per me stessa, sarei schiacciata nelle fantasie di altre persone e mangiata viva.'
  },
  {
    source: 'Viola Davis',
    text: '"Non ho tempo di stare alzata tutta la notte a preoccuparmi di quello che ha da dire su di me qualcuno che non mi ama.'
  },
  {
    source: 'Frederick Douglass',
    text: 'Ho pregato per vent’anni ma non ho ricevuto alcuna risposta fino a quando non ho pregato con le mie gambe.'
  },
  {
    source: 'Barack Obama ',
    text: 'Il cambiamento non avverrà se aspettiamo che arrivi un’altra persona, o un altro tempo. Noi siamo quelli che stavamo aspettando. Noi siamo il cambiamento che stavamo cercando.'
  },
  {
    source: 'James Baldwin',
    text: 'Non esiste un momento futuro in cui potremo lavorare alla nostra salvezza. La sfida si pone nel momento e il momento è sempre adesso.'
  },
  {
    source: 'Dr. Martin Luther King, Jr.',
    text: 'Se non puoi volare allora corri, se non puoi correre allora cammina, se non puoi camminare allora striscia, ma qualsiasi cosa tu faccia devi continuare ad andare avanti.'
  },
  {
    source: 'Dr. Mae Jamison',
    text: 'Non farti mai limitare dall’immaginazione limitata degli altri.'
  },
  {
    source: 'Phylicia Rashad',
    text: 'C’è sempre qualcosa che ti fa pensare che non riuscirai mai a diventare chi volevi essere. Puoi scegliere se accettarlo o continuare ad andare avanti.'
  },
  {
    source: 'Beyoncé Knowles',
    text: 'Il potere non ti viene dato.  Sei tu che devi prenderlo.'
  },
  {
    source: 'Arthur Ashe',
    text: 'Una chiave importante per il successo è la fiducia in se stessi. Una chiave importante per la fiducia in sé stessi è la preparazione.'
  },
  {
    source: 'Frank Sinatra',
    text: 'La migliore vendetta è un enorme successo.'
  },
  {
    source: 'Steve Jobs',
    text: 'Il tuo tempo è limitato, quindi non sprecarlo vivendo la vita di qualcun altro.'
  },
  {
    source: 'Zig Ziglar',
    text: 'La gente spesso dice che la motivazione non dura. Beh, nemmeno lavarsi. Ecco perché lo raccomandiamo ogni giorno.'
  },
  {
    source: 'Jim Rohn',
    text: 'Sei la media delle cinque persone che frequenti di più.'
  },
  {
    source: 'Vince Lombardi',
    text: ' La differenza tra una persona di successo e un’altra non è una mancanza di forza, non una mancanza di conoscenza, ma piuttosto una mancanza di volontà'
  },
  {
    source: 'Bruce Lee',
    text: 'Se ami la vita, non perdere tempo, perché il tempo è ciò di cui è fatta la vita.'
  },
  {
    source: 'Abraham Lincoln',
    text: 'Tutto arriva a chi sa aspettare, ma solo le cose lasciate da chi si è già dato da fare.'
  },
  {
    source: 'John Lennon',
    text: 'La vita è ciò che accade mentre sei occupato a fare altri progetti.'
  },
  {
    source: 'Angelica Monroy',
    text: 'Abbraccia le tue vulnerabilità, accettale e perdona te stesso.'
  },
  {
    source: 'Iris Soto',
    text: 'Di fronte alle sfide difficili ricorda che sono delle benedizioni sotto mentite spoglie, affrontale con fede.'
  },
  {
    source: 'Carlos Santana',
    text: 'Il bene più prezioso che puoi possedere è un cuore aperto. L’arma più potente che puoi essere è uno strumento di pace.'
  },
  {
    source: 'Cesar Chavez ',
    text: 'La conservazione della propria cultura non richiede disprezzo o mancanza di rispetto per le altre culture.'
  },
  {
    source: 'Gwendolyn Brooks',
    text: 'Non permettete a nessuno di chiamarvi minoranza se siete neri o ispanici o appartenete a qualche altro gruppo etnico. Non siete inferiori a nessuno.'
  },
  {
    source: 'Dolly Parton ',
    text: 'Per come la vedo io, se vuoi l’arcobaleno, devi sopportare la pioggia.'
  },
  {
    source: 'Dr. Seuss',
    text: 'Talvolta non capisci il vero valore di un momento finché non diventa ricordo.'
  },
  {
    source: 'C.S. Lewis',
    text: 'Non si è mai troppo vecchi per fissare un altro obiettivo o sognare un nuovo sogno.'
  },
  {
    source: 'Hellen Keller',
    text: 'Non piegare mai la testa. Tienila sempre alta. Guarda il mondo dritto negli occhi.'
  },
  {
    source: 'Theodore Roosevelt',
    text: 'Se credi di poterlo fare sei già a metà strada.'
  },
  {
    source: 'Carol Burnett',
    text: 'Quando hai un sogno, devi afferrarlo e non lasciarlo mai andare.'
  },
  {
    source: 'Albert Einstein',
    text: 'La vita è come andare in bicicletta: se vuoi stare in equilibrio, devi continuare a muoverti.'
  },
  {
    source: 'Ella Fitzgerald',
    text: 'Non rinunciare a provare a fare ciò che vuoi veramente fare. Dove c’è amore e ispirazione, non credo che si possa sbagliare.'
  },
  {
    source: 'Amy Poehler',
    text: 'Limitate i vostri "sempre" e i vostri "mai".'
  },
  {
    source: 'Maya Angelou',
    text: 'Sii un arcobaleno nella nuvola di qualcun altro.'
  },
  {
    source: '"Camilla Eyring Kimball',
    text: 'Non trovi la vita felice. Sei tu che la crei.'
  },
  {
    source: 'E.E. Cummings',
    text: 'Il più sprecato dei giorni è quello senza risate.'
  },
  {
    source: 'George Eliot',
    text: 'Non è mai troppo tardi per essere quello che avresti potuto essere.'
  },
  {
    source: 'Hazrat Inayat Khan',
    text: 'Alcune persone cercano un bel posto. Altre rendono bello un posto.'
  },
  {
    source: 'Lindsey Von',
    text: 'La vita cambia molto rapidamente, in modo molto positivo, se glielo permetti.'
  },
  {
    source: 'Malala Yousafzai',
    text: 'Creiamo il nostro futuro ora, e lasciamo che i nostri sogni diventino realtà domani.'
  },
  {
    source: 'Mandy Hale',
    text: 'Non hai sempre bisogno di un piano. A volte devi solo respirare, fidarti, lasciarti andare e vedere cosa succede.'
  },
  {
    source: 'Meghan Markle',
    text: 'Sei già abbastanza così come sei.'
  },
  {
    source: 'Martin Luther King Jr.',
    text: 'Se non posso fare grandi cose, posso fare piccole cose in modo grandioso.'
  },
  {
    source: 'Nicole Kidman',
    text: 'La vita ha mille curve e tornati. Tieniti forte e Devi tenerti stretto e vai avanti.'
  },
  {
    source: 'Oprah Winfrey',
    text: 'Se guardi ciò che hai nella vita, avrai sempre di più.'
  },
  {
    source: 'Reese Witherspoon',
    text: 'Con la giusta preparazione e determinazione si può realizzare qualsiasi cosa.'
  },
  {
    source: 'Roald Dahl',
    text: 'Se hai dei buoni pensieri, risplenderanno sul tuo viso come raggi di sole e sarai sempre bella.'
  },
  {
    source: 'Robin Williams',
    text: 'Non importa quello che la gente ti dice, le parole e le idee possono cambiare il mondo.'
  },
  {
    source: 'Rosa Parks',
    text: 'Ogni persona deve vivere la propria vita come modello per gli altri.'
  },
  {
    source: 'Serena Williams',
    text: 'Un campione non è definito dalle sue vittorie, ma da come riesce a riprendersi quando cade.'
  },
  {
    source: 'Sheryl Sandberg',
    text: 'La motivazione viene dal lavorare sulle cose che ci interessano.'
  },
  {
    source: 'Walt Whitman',
    text: 'Tieni il viso sempre rivolto verso il sole e le ombre cadranno dietro di te.'
  },
  {
    source: 'John Bunyan',
    text: 'Non hai vissuto oggi finché non hai fatto qualcosa per qualcuno che non potrà mai ripagarti.'
  },
  {
    source: 'Walt Whitman',
    text: 'Ogni momento di luce e di buio è un miracolo.'
  },
  {
    source: 'Will Rogers',
    text: 'Anche se sei sulla strada giusta, verrai investito se rimani seduto.'
  },
  {
    source: 'Mark Zuckerberg',
    text: 'Il più grande rischio è non correre alcun rischio... In un mondo che cambia molto velocemente, l’unica strategia che è garantita a fallire non è quella di rischiare.'
  },
  {
    source: 'Napolean Hill',
    text: 'Ciò che la mente può concepire, può realizzarlo.'
  },
  {
    source: 'Ted Murphy',
    text: 'Se non fa un po’ paura, probabilmente non vale il tuo tempo.'
  },
  {
    source: 'Sydney Harris',
    text: 'Quando sento qualcuno sospirare: "La vita è dura", sono sempre tentato di chiedere: "Rispetto a cosa?"'
  },
  {
    source: 'Arthur Schopenhauer',
    text: 'Ogni verità passa attraverso tre fasi. Nella prima è ridicolizzata. Nella seconda è osteggiata. Nella terza diviene di per se stessa evidente.'
  },
  {
    source: 'John F. Kennedy',
    text: 'Se non noi, chi? Se non ora, quando?'
  },
  {
    source: 'Jack Canfield ',
    text: 'Non preoccupatevi dei fallimenti, preoccupatevi delle occasioni perse quando nemmeno ci provate.'
  },
  {
    source: 'Sir Claus Moser',
    text: 'L’istruzione costa. Ma anche l’ignoranza.'
  },
  {
    source: 'John Wooden',
    text: 'Non lasciare mai che ciò che non puoi fare interferisca con ciò che puoi fare.'
  },
  {
    source: 'Babe Ruth',
    text: 'Ogni strike mi porta più vicino al prossimo home run.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text: 'Le nostre vite cominciano a finire il giorno in cui diventiamo silenziosi sulle cose che contano.'
  },
  {
    source: 'Maya Angelou',
    text: 'Il pregiudizio è un fardello che confonde il passato, minaccia il futuro e rende inaccessibile il presente.'
  },
  {
    source: 'Rosa Parks',
    text: 'Per portare il cambiamento, non bisogna aver paura di fare il primo passo. Falliremo quando non riusciremo a provarci.'
  },
  {
    source: 'James Baldwin',
    text: 'Non tutto ciò che viene affrontato può essere cambiato, ma niente può essere cambiato finché non viene affrontato.'
  },
  {
    source: 'Dr. Martin Luther King Jr.',
    text: 'L’oscurità non può scacciare l’oscurità, solo la luce può farlo. L’odio non può scacciare l’odio, solo l’amore può farlo.'
  },
  {
    source: 'Malcolm X',
    text: 'Se non ti alzi in piedi per qualcosa, cadrai per qualsiasi cosa.'
  },
  {
    source: 'Dr. Cornel West',
    text: 'La giustizia è l’aspetto dell’amore che si manifesta in pubblico.'
  },
  {
    source: 'Malcolm X',
    text: 'Non si può separare la pace dalla libertà perché nessuno può essere in pace senza avere libertà.'
  },
  {
    source: 'Andrew Hendrixson',
    text: 'Chiunque abbia mai fatto qualcosa di importante lo ha fatto con disciplina.'
  },
  {
    source: 'Coco Chanel',
    text: 'Non passare il tempo a battere contro un muro, sperando di trasformarlo in una porta.'
  },
  {
    source: 'Albert Einstein',
    text: 'La creatività è l’intelligenza che si diverte.'
  },
  {
    source: 'Grace Coddington',
    text: 'Tieni sempre gli occhi aperti. Continua a guardare. Perché qualsiasi cosa tu veda può ispirarti.'
  },
  {
    source: 'Henry David Thoreau',
    text: 'Ciò che ottieni raggiungendo i tuoi obiettivi non è importante quanto quello che diventi raggiungendo i tuoi obiettivi.'
  },
  {
    source: 'Seth Godin',
    text: 'Invece di chiederti quando sarà la tua prossima vacanza, forse dovresti creare una vita da cui non hai bisogno di scappare.'
  },
  {
    source: 'John Maxwell',
    text: 'A volte si vince, a volte si impara.'
  },
  {
    source: 'Audre Lorde',
    text: 'Prendersi cura di me stesso non è autoindulgenza, è autoconservazione, e questo è un atto di guerra politica.'
  },
  {
    source: 'Assata Shakur',
    text: 'Sogni e realtà sono opposti. L’azione li sintetizza.'
  },
  {
    source: 'Wangari Maathai',
    text: 'Ci sono opportunità anche nei momenti più difficili.'
  },
  {
    source: 'Rev. Peter Marshall',
    text: '"Possiamo pensare alla libertà non come al diritto di fare ciò che vogliamo, ma come all’opportunità di fare ciò che è giusto.'
  },
  {
    source: 'Martha Grimes',
    text: 'Non sappiamo chi siamo finché non vediamo cosa siamo in grado di fare.'
  },
  {
    source: 'Vidal Sassoon ',
    text: 'Accetta un buon consiglio, assicurati che sia un buon consiglio, poi fai a modo tuo.'
  },
  {
    source: 'Adelaide Anne Procter',
    text: 'Possiamo sempre essere quello che avremmo potuto essere.'
  },
  {
    source: 'George Patton',
    text: 'Mai dire alle persone come fare le cose. Dite loro che cosa fare e vi sorprenderanno con il loro ingegno.'
  },
  {
    source: 'Robert Frost ',
    text: 'La maggior parte del cambiamento che pensiamo di vedere nella vita è dovuto a verità favorevoli e sfavorevoli.'
  },
  {
    source: 'Bob Black',
    text: 'Sei ciò che fai. Se fai un lavoro noioso, stupido e monotono, è probabile che finirai per essere noioso, stupido e monotono.'
  },
  {
    source: 'Georg Wilhelm Friedrich Hegel',
    text: 'Nel mondo nulla di grande è stato fatto senza passione.'
  },
  {
    source: 'Robert Louis Stevenson',
    text: 'Non giudicare ogni giorno dal raccolto che raccogli ma dai semi che pianti.'
  },
  {
    source: 'Friedrich Nietzsche',
    text: 'Vi è al mondo una strada, un’unica strada che nessun altro può percorrere salvo te: dove conduce? Non chiedertelo, cammina!'
  },
  {
    source: 'Pablo Picasso ',
    text: 'L’arte è la menzogna che ci permette di conoscere la verità. '
  },
  {
    source: 'Henry David Thoreau',
    text: 'Se uno avanza con fiducia nella direzione dei suoi sogni, e si sforza di vivere la vita che ha immaginato, incontrerà un successo inaspettato nelle ore comuni.'
  },
  {
    source: 'Bob Dylan',
    text: 'Non è nell’interesse di nessuno pensare a come sarà percepito domani. Alla lunga fa male.'
  },
  {
    source: 'Stephen Vincent Benet',
    text: 'La vita non si perde morendo! La vita si perde minuto per minuto, trascinandosi giorno per giorno, in tutti i mille, piccoli, indifferenti modi.'
  },
  {
    source: 'Mary Shelley',
    text: 'Non c’è niente di più doloroso per la mente umana di un improvviso, assoluto cambiamento.'
  },
  {
    source: 'E.M. Forster',
    text: 'O la vita comporta coraggio, o cessa di essere vita.'
  },
  {
    source: 'Ellen DeGeneres',
    text: 'Ho imparato la compassione dall’essere discriminato. Tutto ciò che di brutto mi è successo mi ha insegnato la compassione.'
  },
  {
    source: 'James Cameron',
    text: 'Il fallimento deve essere un’opzione. ... Nessuna impresa importante che abbia richiesto innovazione è stata fatta senza rischi.'
  },
  {
    source: 'Mandy Hale',
    text: 'Sii abbastanza audace da vivere la vita alle tue condizioni, e non scusarti mai per questo.'
  },
  {
    source: 'Debbi Fields',
    text: 'Il più grande fallimento nella vita è non provare mai.'
  },
  {
    source: 'Elizabeth Barrett Browning',
    text: 'Non misurare il lavoro finché il giorno non è finito e il lavoro è fatto.'
  },
  {
    source: 'Ingvar Kamprad',
    text: 'Commettere errori è il privilegio degli attivi, di coloro che possono correggere i loro errori e metterli a posto.'
  },
  {
    source: 'Leo Tolsto',
    ttext: 'Tutti pensano di cambiare l’umanità e nessuno pensa di cambiare se stesso.'
  },
  {
    source: 'Aldous Huxley',
    text: 'C’è solo un angolo dell’universo che puoi essere certo di migliorare, e quello sei tu.'
  },
  {
    source: 'Theodore Thornton Munger',
    text: 'non c’è niente di più comune di uomini pieni di talento ma privi di successo.'
  },
  {
    source: 'Steve Jobs',
    text: 'Sono convinto che circa la metà di ciò che separa gli imprenditori di successo da quelli senza successo sia la pura perseveranza. È così difficile.'
  },
  {
    source: 'Dwight D. Eisenhower',
    text: 'I piani sono inutili, ma la pianificazione è indispensabile.'
  },
  {
    source: 'Booker T. Washington',
    text: 'Ci sono due modi di esercitare la propria forza: uno è spingere verso il basso, l’altro è tirare verso l’alto.'
  },
  {
    source: 'James Thurber',
    text: 'Non guardiamo indietro con rabbia, né avanti con paura, ma intorno con consapevolezza.'
  },
  {
    source: 'Nelson Mandela',
    text: 'Possano le tue scelte riflettere le tue speranze, non le tue paure.'
  },
  {
    source: 'Steve Jobs',
    text: 'Le cose non devono per forza cambiare il mondo per essere importanti.'
  },
  {
    source: 'Albert Einstein',
    text: 'La pace non può essere mantenuta con la forza; può essere raggiunta solo con la comprensione.'
  },
  {
    source: 'Frederick Douglass',
    text: 'L’anima che è dentro di me nessun uomo potrà degradare.'
  },
  {
    source: 'Peter Drucker',
    text: 'La cosa più importante nella comunicazione è ascoltare ciò che non viene detto.'
  },
  {
    source: 'Molière',
    text: 'È un buon condimento per la gioia pensare a coloro che amiamo.'
  },
  {
    source: 'William Feather',
    text: 'Nessun uomo è un fallito se si gode la vita.'
  },
  {
    source: 'Pablo Picasso',
    text: 'Impara le regole come un professionista, così potrai infrangerle come un artista.'
  },
  {
    source: 'Ursula Le Guin',
    text: 'È bene avere una meta verso cui viaggiare, ma è il viaggio in sé che conta, alla fine.'
  },
  {
    source: 'John F. Kennedy',
    text: 'Il conformismo è il carceriere della libertà e il nemico della crescita.'
  },
  {
    source: 'Robert Anthony',
    text: 'Alcune persone bevono alla fontana della conoscenza. Altri fanno solo i gargarismi.'
  },
  {
    source: 'Ralph Waldo Emerson',
    text: 'Ogni artista è stato prima un dilettante.'
  },
  {
    source: 'Samuel Butler',
    text: 'A parte l’uomo, tutti gli animali sanno che lo scopo principale della vita è godersela.'
  },
  {
    source: 'Bruce Lee',
    text: 'Assorbi ciò che è utile, scarta ciò che non lo è, aggiungi ciò che è unicamente tuo.'
  },
  {
    source: 'Earl Nightingale',
    text: 'Noi diventiamo ciò che pensiamo.'
  },
  {
    source: 'Theodore Vail',
    text: 'Le difficoltà reali possono essere superate; solo quelle immaginarie sono insuperabili.'
  },
  {
    source: 'Washington Irving',
    text: 'Le piccole menti sono domate e sottomesse dalle avversità, ma le grandi menti si elevano al di sopra di esse.'
  },
  {
    source: 'Arnold Bennett',
    text: 'Qualsiasi cambiamento, anche un cambiamento in meglio, è sempre accompagnato da inconvenienti e disagi.'
  },
  {
    source: 'Dhirubhai Ambani',
    text: 'Se non costruisci il tuo sogno, qualcun altro ti assumerà per aiutarlo a costruire il suo.'
  },
  {
    source: 'Mario Andretti',
    text: 'Se hai tutto sotto controllo vuol dire che non stai andando abbastanza veloce.'
  },
  {
    source: 'Oprah Winfrey',
    text: 'Sii grato per quello che hai e finirai per averne di più. Se ti concentri su ciò che non hai, non avrai mai, mai abbastanza.'
  },
  {
    source: 'Helen Keller',
    text: 'Evitare il pericolo non è più sicuro a lungo termine che esporsi apertamente. I timorosi cadono tanto spesso quanto gli audaci.'
  },
  {
    source: 'Thomas Paine',
    text: 'Più duro è il conflitto, più glorioso è il trionfo.'
  },
  {
    source: 'Frank Tyger',
    text: 'Non c’è prestito più grande che quello di un orecchio comprensivo.'
  },
  {
    source: 'Phyllis Theroux',
    text: 'Gli errori sono il solito ponte tra inesperienza e saggezza.'
  },
  {
    source: 'Gaylord Nelson',
    text: 'La prova definitiva della coscienza dell’uomo può essere la sua disponibilità a sacrificare qualcosa oggi per le generazioni future le cui parole di ringraziamento non saranno ascoltate.'
  },
  {
    source: 'Sarah Grand',
    text: 'La nostra opinione sulle persone dipende meno da quello che vediamo in loro e più da quello che ci fanno vedere di noi stessi.'
  },
  {
    source: 'George Santayana',
    text: 'Non v’è rimedio per la nascita e la morte salvo godersi l’intervallo.'
  },
  {
    source: 'Margaret Chase Smith',
    text: 'Quando la gente continua a dirti che non puoi fare una cosa, allora dovresti provarci.'
  },
  {
    source: 'André Gide',
    text: 'Credi in coloro che cercano la verità. Dubita di coloro che la trovano.'
  },
  {
    source: 'Frank Yerby',
    text: 'La maturità è raggiunta il giorno in cui non abbiamo bisogno che ci si menta su nulla.'
  },
  {
    source: 'Charles Dickens',
    text: 'Nessuno è inutile in questo mondo se è capace di alleggerire i pesi di un altro uomo.'
  },
  {
    source: 'Merry Browne',
    ttext:
      'Aspettatevi che le persone siano migliori di quello che sono; questo le aiuterà a diventare migliori. Ma non essere deluso quando non lo sono; questo le aiuterà a continuare a provare.'
  },
  {
    source: 'Doug Larson',
    text: 'La saggezza è la qualità che ti impedisce di trovarti in situazioni in cui ne hai bisogno.'
  },
  {
    source: 'Laozi',
    text: 'Per raggiungere la conoscenza aggiungi qualcosa ogni giorno. Per conquistare la saggezza togli qualcosa ogni giorno.'
  }
]
